import { FC, ReactNode, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { Header } from './Header';
import { Sidebar, MobileSidebar } from './Sidebar';

interface AppLayoutProps {
  children: ReactNode;
}

/**
 * アプリケーション共通レイアウトコンポーネント
 * Header + Sidebar + Content エリア
 */
export const AppLayout: FC<AppLayoutProps> = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMenuClick = () => {
    setIsMobileMenuOpen(true);
  };

  const handleMenuClose = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <Box minH="100vh" bg="gray.50">
      {/* ヘッダー */}
      <Header onMenuClick={handleMenuClick} />

      {/* サイドバー（デスクトップ） */}
      <Sidebar />

      {/* サイドバー（モバイル） */}
      <MobileSidebar isOpen={isMobileMenuOpen} onClose={handleMenuClose} />

      {/* コンテンツエリア */}
      <Box
        ml={{ base: 0, lg: '60' }}
        minH="calc(100vh - 4rem)"
        transition="margin-left 0.2s"
      >
        <Box p={{ base: 4, md: 6 }}>{children}</Box>
      </Box>
    </Box>
  );
};
